<template>

    <div v-cloak class="container-fluid">

        <div v-if="isLoading">
            <div class="loading-div" v-if="isLoading">{{ isLoadingContent }}</div>
        </div>

        <div v-else>
            <div class="row">
                <div class="col">
                    <h4 class="text-portal-soft-black pt-2" v-once>{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h4>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="mt-0 mb-0 border-none taller-hr">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <h5 class="text-portal-soft-black" v-once>{{cmsContentBlocks['clinicalGenetics.Header']}}</h5>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                    <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
                </div>
            </div>

            <div class="row mt-2 mt-lg-0">
                <div class="col">

                    <div class="row">
                        <div class="col">
                            <hr>
                        </div>
                    </div>

                    <div>
                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                <label for="to-mailbox">{{cmsContentBlocks['clinicalGenetics.ToMailboxLabel']}}</label>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="row mb-2">
                            <div class="col">
                                <select2-component id="to-mailbox" key="toCounselorId" :disableresultsort="true" v-error-message="{ errorModel: 'errorModel.toCounselorId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="referenceData.geneticCounselorDropDown" v-model="messageModel.toCounselorId" :placeholder="cmsContentBlocks['clinicalGenetics.ToDropDownPlaceHolder']">
                                </select2-component>
                                <span class="invalid-feedback is-invalid">{{ errorModel.toCounselorId | firstError }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            <label for="subject">{{cmsContentBlocks['clinicalGenetics.SubjectLabel']}}</label>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            <div v-if="selectedCounselorIsEffort">
                                <input type="text" readonly="readonly" class="form-control" :value="referenceData.subjectForEffortReferenceData.text" />
                            </div>
                            <div v-else>
                                <select2-component id="subject" key="subjectId" v-error-message="{ errorModel: 'errorModel.subjectId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="referenceData.subjectNotForEffortReferenceData" v-model="messageModel.subjectId" :placeholder="cmsContentBlocks['clinicalGenetics.SubjectDropDownPlaceHolder']">
                                </select2-component>
                                <span class="invalid-feedback is-invalid">{{ errorModel.subjectId | firstError }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                            <message-body-component v-model="messageModel.messageBody"
                                                    :error-model="errorModel"
                                                    :cms-content-blocks="cmsContentBlocks"
                                                    :non-english="nonEnglish"
                                                    :text-area-style-object="{ height: '200px !important' }"></message-body-component>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <upload-component :attachment-group-id="attachmentGroupId">
                                <template v-slot:multiple-error-slot>
                                    <span class="invalid-feedback is-invalid d-inline">{{ errorModel.attachmentGroupId | firstError }}</span>
                                </template>
                            </upload-component>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

    import jlinq from '@SharedServices/linq.javascript.service';
    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import composeMessageBody from '../../Common/message.body.vue';
    import uploadComponent from '@PortalVueComponents/Uploader/file.multiple.uploader.vue';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import { ResolveStaticContent } from '@SharedServices/localization.service';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue';
    import { MessageHttpSvc } from '@SharedHttpServices/message.httpservice';

    export default {
        name: 'clinicalGeneticsTemplate',
        props: {
            errorModel: { type: Object },
            attachmentGroupId: { type: String },
            cmsContentBlocks: { type: Object },
            nonEnglish: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'message-body-component': composeMessageBody,
            'upload-component': uploadComponent,
            'banner-component': mskBanner
        },
        data: function () {
            return {

                isLoading: true,

                referenceData: {
                    counselorIdForEffort: null,
                    subjectForEffortReferenceData: {},
                    subjectNotForEffortReferenceData: [],
                    geneticCounselorDropDown: [],
                },

                messageModel: {
                    toCounselorId: null,
                    subjectId: null,
                    attachmentGroupId: this.attachmentGroupId,
                    messageBody: '',
                },
            }
        },
        created: async function () {

            const pageData = await MessageHttpSvc.ClinicalGeneticsComposeTemplateInit();

            this.referenceData.geneticCounselorDropDown = pageData.counselorReferenceData;
            this.referenceData.counselorIdForEffort = pageData.counselorIdForEffort;
            this.referenceData.subjectForEffortReferenceData = pageData.subjectForEffortReferenceData;
            this.referenceData.subjectNotForEffortReferenceData = pageData.subjectNotForEffortReferenceData;
            this.isLoading = false;
        },
        mounted: function () {

            //go send back the model right away
            this.$emit('setMessageObject', this.messageModel);
        },
        computed: {
            isLoadingContent: function () {
                return ResolveStaticContent("Loading");
            },

            selectedCounselorIsEffort: function () {
                return this.messageModel.toCounselorId == this.referenceData.counselorIdForEffort;
            }
        },
        watch: {

            messageModel: {
                handler: function (newValue) {
                
                    //if effort is in play
                    if (this.referenceData.subjectForEffortReferenceData) {
                        //effort is selected. Select the 1 subject
                        if (newValue.toCounselorId == this.referenceData.counselorIdForEffort) {
                            this.messageModel.subjectId = this.referenceData.subjectForEffortReferenceData.id;
                        }
                        else if (this.messageModel.subjectId == this.referenceData.subjectForEffortReferenceData.id) {
                            //effort is not selected. so we want to reset the subject
                            this.messageModel.subjectId = null;
                        }
                    }

                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            }
        }
    };
</script>

